module.exports = __webpack_public_path__ + "img/cent-sign.9fdbf6b3.svg";